<template>
  <transition name="bounce">
    <div v-if="!pointPanel.show" class="search-panel">
      <input
        v-model="search"
        type="search"
        :placeholder="
          searchType
            ? 'Введите современное слово...'
            : 'Введите диалектное слово...'
        "
        @focus="focused = true"
        @keyup.enter="searching"
        @keydown="clearSearchDescriptionResults"
        :class="{ redLabelBorder: searchType }"
        id="simplesearch"
      />
      <at-button
        type="warning"
        icon="icon-sliders"
        :title="pointPanel.head"
        circle
        @click="closeMe"
        style="position: absolute; left: 18px; top: 18px; outline: none"
        :class="{ redLabelBack: searchType }"
      ></at-button>

      <at-button
        type="warning"
        icon="icon-search"
        title="Поиск"
        circle
        style="position: absolute; right: 18px; top: 18px; outline: none"
        @click="searching"
        :class="{ redLabelBack: searchType }"
      ></at-button>

      <at-switch
        v-model="searchType"
        @change="setSearchType"
        :key="searchType"
      />
      <div
        class="switch-label-up"
        :class="{ SwitchLabelIsActive: !searchType }"
      >
        по словам
      </div>
      <div
        class="switch-label-down"
        :class="{ SwitchLabelIsActive: searchType, redLabel: searchType }"
      >
        по определениям
      </div>

      <transition name="fade">
        <div v-if="focused" class="searchblock">
          <span v-if="terms.length == 0" v-html="searchInfoText" />
          <div v-else style="border-bottom: 1px solid gray; width: 100%">
            Найдено {{ wordsCountInformer(terms.length) }}
            <span v-if="selectedTermsLength > 0" class="del-all-btn" @click="unselectAll">Снять выбор везде</span> 
            <span v-if="currentSearchTerms.length > 0" class="del-all-btn" @click="unselectSearch">Снять выбор</span> 
          </div>
          <div id="simpletermlist">
            <div v-for="term in limitedTerms" :key="term.id" class="searchitem">
              <at-checkbox
                v-model="term.selected"
                :label="term.id"
                title="Добавить на карту"
                @on-change="select(term)"
                @mouseenter.native="loadDesc(term)">
                  {{ termLabelText(term) }}
                </at-checkbox>
            </div>
            <at-button
              id="simpletermListBottomFlag"
              v-if="$store.state.terms.termsLimit < terms.length"
              type="text"
              style="width: 100%"
              @click="$store.state.terms.termsLimit += 50"
              >Показать ещё</at-button
            >
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: ["pointPanel", "mapClick"],
  computed: {
    // выбранные точки в текущем поиске
    currentSearchTerms() {
      return this.terms.filter(term => term.selected)
    },
    // подсказки под полем поиска
    searchInfoText() {
      return this.searchType
        ? !this.search
          ? "Введите поисковый запрос и нажмите &#128269; или Enter↵"
          : this.waitForSearch
          ? "Выполняется поиск..."
          : this.searchContuned
          ? "По введённому запросу определений не найдено"
          : "Введите поисковый запрос и нажмите &#128269; или <kbd>Enter↵</kbd>" 
        : !this.search
        ? "Словарь загружается..."
        : "Введённое слово в словаре отсутствует";
    },
    // поле поиска с настройкой под оба режима
    search: {
      get() {
        if (this.searchType) return this.$store.getters.getSearchDescription;
        return this.$store.getters.getSearch;
      },
      set(search) {
        if (this.searchType)
          this.$store.commit("setSearchDescription", { search });
        else this.$store.commit("setSearch", { search });
      },
    },
    // режим поиска
    searchType: {
      get() {
        return this.$store.getters.getSearchType;
      },
      set(searchType) {
        this.$store.commit("setSearchType", { searchType });
      },
    },
    // слова, отображаются в зависимости от настроек фильтров и поля поиска
    terms() {
      if (this.searchType) {
        return this.$store.getters.getDescriptionSearchResults;
      }
      if (this.search != "") return this.$store.getters.getSearchResults;
      return this.$store.getters.termfilter;
    },
    // ограничение по количеству выводимых терминов
    limitedTerms() {
      return this.terms.slice(0, this.$store.state.terms.termsLimit);
    },
    // список выбранных слов
    selectedTermsLength() {
      return this.$store.state.terms.termstack.length;
    },
  },
  data: () => ({
    // интерфейсные флаги
    // флаг - поиск в фокусе
    focused: false,
    // флаг - ожидание ответа сервера
    waitForSearch: false,
    // флаг - поиск завершен
    searchContuned: false,
  }),
  watch: {
    // отслеживание изменений в поле поиска
    search() {
      // скрытие информера
      this.closenotify();
      // сброс уровня прокрутки
      this.$store.state.terms.termsLimit = 100;
      // очистка результатов поиска, если поле поиска очищено
      if (this.search == "") this.clearSearchDescriptionResults();
    },
    focused() {
      // при активации поля поиска реактивируется автопрокрутка
      if (this.focused)
        setTimeout(() => {
          document
            .getElementById("simpletermlist")
            .addEventListener("scroll", this.handleScroll);
        }, 100);
    },
    // отслеживание кликов по карте для скрытия результатов поиска
    mapClick() {
      this.unfocused();
    },
  },
  methods: {
    // текст в списке найденных точек
    termLabelText(term) {
      return term.name + (term.description ? " - " + term.description : "")
    },
    // обработчик кнопки Искать
    searching() {
      // если есть, что искать ...
      if (this.search) {
        // ... выбран режим поиска СЛОВА, но ничего не найдено, меняем режим поиска
        if (!this.searchType && this.terms.length == 0) {
          var search = this.search;
          this.search = "";
          this.searchType = true;
          this.search = search;
        }
        // очищаем прошлые результаты поиска
        this.$store.commit("clearSearchDescriptionResults");
        // запускаем поиск
        this.waitForSearch = true;
        this.$store
          .dispatch("SearchingInTermDescriptions", this.search)
          .then(() => {
            this.waitForSearch = false;
            this.searchContuned = true;
          });
      }
    },
    // спрягаем слова для информера
    wordsCountInformer(n) {
      var r = n % 10;
      var r1 = n % 100;
      if (r1 > 10 && r1 < 20) return n + " слов";
      if (r == 1) return n + " слово";
      if (r < 5 && r > 1) return n + " слова";
      return n + " слов";
    },
    // очистка списка поиска
    unselectSearch() {
      // снимаем галочки со всех терминов без разбора
      this.currentSearchTerms.forEach(term => {
        term.selected = false;
        this.$store.commit('delTermFromTermsstack', term);
      });
      // обновляем карту
      this.$store.dispatch("rePrintPoints");
    },
    // очистка списка отложенного
    unselectAll() {
      // снимаем галочки со всех терминов без разбора
      this.$store.state.terms.filter.forEach((term) => {
        term.selected = false;
      });
      // обновляем карту
      this.$store.dispatch("rePrintPoints");
      // очищаем список отложенного
      this.$store.commit('delAllTermsFromTermsstack');
    },
    // потеря фокуса полем поиска
    unfocused() {
        this.focused = false;
        // сброс уровня прокрутки
        this.$store.state.terms.termsLimit = 100;
    },
    // закрытие формы поиска. Задержки - декоративные
    closeMe() {
      // убираем фокус с поля поиска
      this.unfocused();
      // закрываем всплывающее окно
      this.closenotify();
      // закрываем форму поиска
      document.simpleSearchTimeout = setTimeout(() => {
        this.$emit("close");
      }, 250);
    },
    // переключатель режима поиска
    setSearchType() {
      // поисковой запрос переносится в новый режим
      var search = this.search;
      this.search = "";
      this.searchType = !this.searchType;
      this.search = search;
      this.$store.commit("clearSearchDescriptionResults");
      // задержки - декоративные
      this.focused = false;
      clearTimeout(document.simpleSearchTimeout);
      document.simpleSearchTimeout = setTimeout(() => {
        document.getElementById("simplesearch").focus();
        // сброс уровня прокрутки
        this.$store.state.terms.termsLimit = 100;
      }, 500);
      // если запрос есть, начинаем поиск автоматически
      if (this.searchType && this.search.length > 0) this.searching();
    },
    // очистка результатов поиска
    clearSearchDescriptionResults() {
      if (this.searchType) {
        this.searchContuned = false;
        this.$store.commit("clearSearchDescriptionResults");
      }
    },
    // клик по найденному слову
    select(term) {
      // закрываем старое окно с описанием
      this.closenotify();
      // подсвечиваем синим маркер последней точки на карте
      this.$store.state.terms.lastId = term.id;
      // перерисуем точки на карте
      this.$store.dispatch("rePrintPoints");
      // если термин выбран, ...
      if (term.selected) {
        // .. загружаем его описание с сервера, открываем окно с описанием
        this.$store.dispatch("getTermDesc", term.id).then(() => {
          this.shownotify(term);
        });
        // добавляем термин в список выбранных
        this.$store.commit('addTermToTermsstack', term);
      } else {
        // удаляем термин из списка выбранных
        this.$store.commit('delTermFromTermsstack', term);
      }
    },
    // закрытие всплывающего окна - информера
    closenotify() {
      this.$store.getters.getNotify.show = false;
    },
    // открытие всплывающего окна - информера
    shownotify(term) {
      this.$store.getters.getNotify.show = true;
      this.$store.getters.getNotify.title = term.name;
      this.$store.getters.getNotify.content = term.description;
    },
    async loadDesc(term) {
      if (!term.description) await this.$store.dispatch("getTermDesc", term.id);
    },
    // озвучивание термина + всплывающее окно
    async speech(term) {
      await this.loadDesc(term);
      var word = term.name + ", это " + term.description;
      this.stopSpeech();
      this.shownotify(term);
      speechSynthesis.speak(new SpeechSynthesisUtterance(word));
    },
    // прервать воспроизведение звука и закрыть инфо
    stopSpeech() {
      this.closenotify();
      speechSynthesis.cancel();
    },
    // автоотображение терминов при прокрутке до низа блока
    handleScroll() {
      if (document.getElementById("simpletermListBottomFlag")) {
        var bottompos =
          document.getElementById("simpletermlist").getBoundingClientRect()
            .top + document.getElementById("simpletermlist").clientHeight;
        var currentpos = document
          .getElementById("simpletermListBottomFlag")
          .getBoundingClientRect().top;
        if (currentpos - bottompos < -10)
          this.$store.state.terms.termsLimit += 50;
      }
    },
  },
};
</script>

<style scoped>
#simpletermlist {
  margin: 0;
  max-height: 40vh;
  overflow-y: auto;
  clear: both;
}

.redLabel {
  color: #ff7d00 !important;
}
.redLabelBack {
  background-color: #ff7d00;
  border-color: #ff7d00 !important;
  direction: ltr;
}
.redLabelBack:hover {
  background-color: #ffb570 !important;
  border-color: #ffb570 !important;
  direction: ltr;
}
.redLabelBack:active {
  background-color: #cb6200 !important;
  border-color: #cb6200 !important;
  direction: ltr;
}
.redLabelBorder {
  border: 0.2rem solid #ff7d00 !important;
  box-shadow: 0px 0px 5px #ff7d00 !important;
}

.switch-label-up {
  position: absolute;
  top: 6px;
  right: 64px;
  font-size: 12px;
  color: #bfbfbf;
  direction: ltr;
}

.switch-label-down {
  position: absolute;
  top: 42px;
  right: 48px;
  font-size: 12px;
  color: #bfbfbf;
  direction: ltr;
}

.SwitchLabelIsActive {
  color: #ffc82c;
  font-weight: bold;
  direction: ltr;
}

.at-switch {
  position: absolute;
  border: 1px solid #ffc82c;
  background-color: #ffc82c;
  top: 25px;
  right: 74px;
  direction: ltr;
}

.at-switch--checked {
  border-color: #ff7d00;
  background-color: #ff7d00;
  direction: ltr;
}

.del-all-btn {
  cursor: pointer;
  font-size: 80%;
  padding-top: 4px;
  color: red;
  float: right;
  padding-left: 10px;
}

.searchitem .at-checkbox {
  width: 100%;
  cursor: pointer;
  height: 30px;
  top: -6px;
  padding-left: 6px;
  padding-top: 8px;
}

.searchitem {
  overflow: hidden;
  height: 24px;
}

.searchitem:hover {
  background-color: rgb(255 204 0 / 19%);
}

.searchblock {
  background: white;
  padding: 10px;
  border-radius: 7px;
  margin: 4px 28px 10px 28px;
  opacity: 0.95;
}

.search-panel {
  position: absolute;
  top: 30px;
  margin-left: auto;
  margin-right: auto;
  left: 0px;
  right: 0px;
  width: 70%;
  min-width: 320px;
  max-width: 800px;
  border-radius: 40px;
  /* z-index: 10; */
}

.search-panel input {
  outline: none;
  border: 0.2rem solid rgb(255, 204, 0);
  box-shadow: 0px 0px 5px rgb(255, 204, 0);
  border-radius: 40px;
  padding: 16px 130px 16px 60px;
  width: 100%;
  font-size: 120%;
  display: inline-block;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>